import { createAction, props } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

import { NetLossLimit, NetLossLimitConfirmation } from "../betting-limit.model";

const ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK = "[Netloss Limit Prompt]";
export const getNetlossLimitConfirmation = createAction(
	`${ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK} Get Netloss Limit Confirmation`
);

export const getNetlossLimitConfirmationSuccess = createAction(
	`${ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK} Get Netloss Limit Confirmation Success`,
	props<{ payload: NetLossLimit }>()
);

export const getNetlossLimitConfirmationFail = createAction(
	`${ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK} Get Netloss Limit Confirmation Fail`,
	props<{ error: AppError }>()
);

export const updateNetLossLimitConfirmation = createAction(
	`${ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK} Update Netloss Limit`,
	props<{ payload: NetLossLimitConfirmation }>()
);

export const updateNetLossLimitConfirmationSuccess = createAction(
	`${ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK} Update Netloss Limit Success`,
	props<{ payload: NetLossLimitConfirmation }>()
);

export const updateNetLossLimitConfirmationFail = createAction(
	`${ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK} Update Netloss Limit Fail`,
	props<{ error: AppError }>()
);

export const netlossConfirmationDialogDisplayed = createAction(
	`${ACTION_PREFIX_NETLOSS_LIMIT_CONFIRMATION_CHECK} Netloss Limit Confirmation Dialog Displayed`
);
